import React, { useMemo } from 'react';
import { SubscriptionInfoContainer, Header, Subheader, HeaderTaxInfo } from './styled';
import { Components, BillingCycleContentKey } from '../../common/interfaces';
import { getErrorMessage } from '../../utils/ErrorUtil';
import { parseHeaderContent, parseSubHeaderContent } from './helper';
import { Strings } from './strings';
import parse from 'html-react-parser';
import { initializeSDK } from '../../utils/CheckoutSdkUtils';
import PricePerDay from '../PricePerDay';
var SubscriptionInfo = function SubscriptionInfo(_ref) {
  var content = _ref.content,
    price = _ref.price,
    onError = _ref.onError,
    headingLevel = _ref.headingLevel,
    authorization = _ref.authorization,
    priceWithDiscount = _ref.priceWithDiscount,
    _ref$isCouponApplied = _ref.isCouponApplied,
    isCouponApplied = _ref$isCouponApplied === void 0 ? false : _ref$isCouponApplied,
    billingCycleContentKey = _ref.billingCycleContentKey,
    saleBanner = _ref.saleBanner,
    dcoExperimentVariation = _ref.dcoExperimentVariation,
    _ref$dcoExperimentVar = _ref.dcoExperimentVariationEnabled,
    dcoExperimentVariationEnabled = _ref$dcoExperimentVar === void 0 ? false : _ref$dcoExperimentVar;
  var authorized = useMemo(function () {
    return initializeSDK({
      authorization: authorization,
      onError: onError,
      componentName: Components.SUBSCRIPTION_INFO
    });
  }, [authorization, onError]);
  if (!content) return null;
  if (!content.header) {
    onError(getErrorMessage(Components.SUBSCRIPTION_INFO, Strings.MISSING_CONTENT_ERROR));
    return null;
  }
  var isMultimonthProduct = !!billingCycleContentKey && billingCycleContentKey !== BillingCycleContentKey.MONTHLY;
  var getHeader = function getHeader() {
    var header = content.header,
      headerWithCoupon = content.headerWithCoupon,
      headerWithDuration = content.headerWithDuration;
    if (isMultimonthProduct && headerWithDuration) {
      return headerWithDuration[billingCycleContentKey];
    }
    if (isCouponApplied && !!priceWithDiscount && !!headerWithCoupon) {
      return headerWithCoupon;
    }
    return header;
  };
  var getSubheader = function getSubheader() {
    var headerWithCoupon = content.headerWithCoupon,
      headerWithDuration = content.headerWithDuration,
      subHeaderRecurring = content.subHeaderRecurring,
      subHeaderWithCoupon = content.subHeaderWithCoupon,
      subHeader = content.subHeader;
    if (isMultimonthProduct && headerWithDuration && subHeaderRecurring) {
      return subHeaderRecurring;
    }
    if (isCouponApplied && !!priceWithDiscount && !!headerWithCoupon && subHeaderWithCoupon) {
      return subHeaderWithCoupon;
    }
    return subHeader;
  };
  var header = getHeader();
  var subheader = getSubheader();
  var headerTaxInfo = content.headerTaxInfo;
  var headerText = isMultimonthProduct && content.headerBillingSummary ? "".concat(header, " - ").concat(content.headerBillingSummary[billingCycleContentKey]) : header;
  var billingCadence = content.billingCadence;
  var cadence = !!billingCycleContentKey && billingCycleContentKey === BillingCycleContentKey.ANNUAL ? billingCadence.annual : billingCadence.monthly;
  var enablePricePerDay = dcoExperimentVariation === 'v1' || dcoExperimentVariation === 'v3';
  return /*#__PURE__*/React.createElement(React.Fragment, null, authorized && /*#__PURE__*/React.createElement(SubscriptionInfoContainer, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, {
    "aria-level": headingLevel,
    "data-test": 'SI-HEADER',
    dcoExperimentVariationEnabled: dcoExperimentVariationEnabled
  }, parse(parseHeaderContent({
    text: dcoExperimentVariationEnabled ? headerText.replace(' -', '') : headerText,
    price: enablePricePerDay ? '' : price,
    cadence: dcoExperimentVariationEnabled ? enablePricePerDay ? '' : '/month' : cadence,
    priceWithDiscount: priceWithDiscount,
    isCouponApplied: isCouponApplied
  })), enablePricePerDay && /*#__PURE__*/React.createElement(PricePerDay, {
    monthlyPrice: parseFloat(price.slice(1))
  }), headerTaxInfo && /*#__PURE__*/React.createElement(HeaderTaxInfo, {
    "data-test": 'SI-HEADER-TAX'
  }, headerTaxInfo)), saleBanner, subheader && /*#__PURE__*/React.createElement(Subheader, {
    "data-test": 'SI-SUBHEADER'
  }, parse(parseSubHeaderContent({
    text: dcoExperimentVariationEnabled ? subheader.replace(/[()]/g, '') : subheader,
    price: price,
    cadence: cadence,
    isCouponApplied: isCouponApplied
  }))))));
};
export default /*#__PURE__*/React.memo(SubscriptionInfo);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/SubscriptionInfo/index.js
// module id = 3994
// module chunks = 11